/**
 * The hidden master's gate and test (docs/systems/FUN_P1.md section 2.3). ผู้เฒ่าเหยียบเมฆ shows himself on the lone spire
 * only after `SECRET.vistasForMaster` vistas. His test: come down from the spire without touching the ground, to the
 * shrine's roof. Rules: systems/hiddenMaster.ts. Data only.
 */
import { RIVER_STONES } from './layouts/yanyu2';
import type { ZoneId } from './zones';

export const MASTER = {
  zone: 'yanyu2' as ZoneId,
  /** The teacher's name in `QINGGONG_TEACHERS` ('hidden-master'). */
  name: 'ผู้เฒ่าเหยียบเมฆ',
  /** The spire top (town metres) and its height; the test arms when the player stands within `spireR` at `spireH`. */
  spire: { x: 300, y: 40, h: 40 },
  spireR: 3,
  /** The roof of ศาลเจ้ากลางน้ำ (box 394-410 x 360-380, eave 9 m) the descent ends on (town metres), how near, and the roof's height (the vista v.shrine's): the roof is reached at that height, on foot or on the wing. */
  shrine: { x: 402, y: 370 },
  shrineR: 5,
  roofH: 9.6,
  roofBand: 1.5,
  /** Standing on a river stone is not touching the ground (the stones' half width, and a little slack). */
  stoneR: 1.5,
  stones: RIVER_STONES,
  /** The pass: แต้มฝึกปรือ and the title. */
  cultivation: 200,
  title: 'cloud-elder-pupil',
  /** The line shown when he first appears. */
  appear: 'มีผู้เฒ่านั่งอยู่บนยอดเสาหินโดดเดี่ยว',
} as const;
